// extracted by mini-css-extract-plugin
export default {"container":"ZonesBedManagementPage_container__4CJcl","containerZonesBeds":"ZonesBedManagementPage_containerZonesBeds__dPWoM","title":"ZonesBedManagementPage_title__QcymK"};